import { PILLARS, COPY } from "@/lib/site";
import { Reveal } from "./Motion";
import { Img } from "./Img";

export const Pillars = () => {
  return (
    <section data-testid="pillars-section" className="grain py-24 md:py-36">
      <div className="container-editorial">
        <Reveal className="max-w-3xl mb-14 md:mb-20">
          <p className="kicker mb-6">{COPY.pillars.kicker}</p>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight">
            {COPY.pillars.headingLead}{" "}
            <span className="italic text-clay">{COPY.pillars.headingEmphasis}</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {PILLARS.map((p, i) => (
            <Reveal
              key={p.title}
              delay={i * 0.08}
              className="group"
              data-testid={`pillar-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="overflow-hidden rounded-sm aspect-[3/4]">
                <Img
                  name={p.img}
                  alt={p.alt}
                  position="center 25%"
                  imgClassName="w-full h-full transition-transform [transition-duration:1400ms] ease-out group-hover:scale-105"
                />
              </div>
              <h3 className="font-display text-3xl mt-5 leading-none">{p.title}</h3>
              <p className="mt-3 text-sm font-light text-ink/65 leading-relaxed">
                {p.desc}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
